<template>
  <!-- Modal konfirmasi hapus data cart-->
  <div id="modalConfirmDeleteItemCart" class="modal fade">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title text-bolder">Konfirmasi</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row py-2">
            <div class="col-12">
              <p style="text-align: left">
                Apakah Anda yakin untuk menghapus {{ dataCartToDelete.ItemName }}?
              </p>
            </div>
          </div>
          <div class="row py-2">
            <div class="col-6"></div>
            <div class="col-6">
              <div class="row">
                <div class="col-6">
                  <button
                    class="btn btn-link btn-block"
                    type="button"
                    data-dismiss="modal"
                  >
                    Batal
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    @click="removeItemCart"
                    class="btn btn-green btn-block"
                  >
                    Ya
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import $ from "jquery";
export default {
  name: "KonfirmHapusItemCartModal",
  data() {
    return {};
  },
  props: {
    dataCartToDelete : Object
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions(["actRemoveItemCart"]),
    removeItemCart() {
        this.$store.dispatch("actRemoveItemCart", this.dataCartToDelete);
        $("#modalConfirmDeleteItemCart").modal("hide");
    },
  },
};
</script>
<style scoped>

</style>